export default {
    // Menu Global
    id: '3',
    routeName: "default",
    interface: 'global',
    label: 'Global',
    isInterface: true,
    show: false,
    items: [
        // Submenu 
        {
            id: '3.0',
            label: 'Fast Market',
            routeName: "index",
            isTitle: false,
            selected: false,
            subItems: []
        },
        // Submenu 
        {
            id: '3.1',
            label: 'Inicio Sesión',
            routeName: "login",
            isTitle: false,
            selected: false,
            subItems: []
        },
        {
            id: '3.2',
            label: 'Cambiar Contraseña',
            routeName: "resetPassword",
            isTitle: false,
            selected: false,
            subItems: []
        },
        {
            id: '3.3',
            label: 'Crear Credenciales',
            routeName: "createCredentials",
            isTitle: false,
            selected: false,
            subItems: []
        },
        // Submenu 
        {
            id: '3.4',
            label: 'Cerrar Sesión',
            routeName: "logout",
            isTitle: false,
            selected: false,
            subItems: []
        },
        // Submenu 
        {
            id: '3.5',
            label: 'Perfil',
            routeName: "profile",
            isTitle: false,
            selected: false,
            subItems: []
        },
        // Submenu 
        {
            id: '3.6',
            label: 'Error 404',
            routeName: "404",
            isTitle: false,
            selected: false,
            subItems: []
        },
        // Submenu 
        {
            id: '3.7',
            label: 'Error 403',
            routeName: "403",
            isTitle: false,
            selected: false,
            subItems: []
        },
        {
            id: '3.8',
            label: 'Mantenimiento',
            routeName: "maintenance",
            isTitle: false,
            selected: false,
            subItems: []
        },
    ]
} 